module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-UltraLightIt.81e7bef8.ttf";